import BaseSyncManager from './BaseSyncManager';

export default class UniticketingSyncManager extends BaseSyncManager {
  // Inherits all methods from BaseSyncManager
}
